export const MAX_DISPLAY_LOCATIONS = 10;
export const ELIGIBLE_CATEGORIES_L2 = ['seating', 'lighting', 'tables', 'storage-case-pieces'];
export const NO_BANNER_REGIONS = ['usa-north-america'];
